import React, { useState, useContext, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Grid } from "@mui/material";
import Request from "../Utils/Request/Request";
import { showToast } from "../Utils/index";
import { AppStorage } from "../Utils/Context/AppContext";
import { useTranslation } from "react-i18next";

function SupplierModal({ close, open, supplier, setForceUpdate }) {
  const initialState = {
    supplierName: "",
    vatNumber: null,
    address: "",
    phoneNumber: null,
  };
  const [formData, setFormData] = useState(initialState);
  const [validated, setValidated] = useState(true);
  const { t, i18n } = useTranslation();

  const AppContext = useContext(AppStorage);

  useEffect(() => {
    if (supplier) {
      let dupObj = { ...formData };
      dupObj.vatNumber = supplier["vatNumber"];
      dupObj.supplierName = supplier["supplierName"];
      dupObj.phoneNumber = supplier["phoneNumber"];
      dupObj.address = supplier["address"];
      setFormData(dupObj);
    }
  }, []);

  const validateFormData = () => {
    if (
      formData.supplierName === "" ||
      formData.vatNumber === null 
    ) {
      setValidated(false);
      return false;
    }
    //  else if (
    //   !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formData.email)
    // )
    //  {
    //   setValidated(false);
    //   return false;
    // }
    setValidated(true);
    return true;
  };

  const handleSubmit = () => {
    if (validateFormData()) {
      let tempData = {
        supplierName: formData.supplierName,
        vatNumber: formData.vatNumber,
        address: formData.address,
        phoneNumber: formData.phoneNumber,
      };
      if (supplier == null) {
        Request.post("/createSupplier", tempData)
          .then((result) => {
            showToast("success", "New Supplier Added");
            close();
            setForceUpdate(true);
            console.log("Data: ", result.data);
          })
          .catch((err) => {
            console.log("Error: ", err);
            if (err.response.status == 401) {
              showToast("error", "Unauthorized user.");
            } else {
              showToast("error", "Something went wrong.");
            }
          });
      } else {
        tempData["id"] = supplier["id"];
        Request.put("/updateSupplier", tempData)
          .then((result) => {
            console.log("Data: ", result.data);
            showToast("success", "Supplier Updated");
            close();
            setForceUpdate(true);
          })
          .catch((err) => {
            console.log("Error: ", err);
            if (err.response.status == 401) {
              showToast("error", "Unauthorized user.");
            } else {
              showToast("error", "Something went wrong.");
            }
          });
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px", // Set your width here
          },
        },
      }}
    >
      <DialogTitle>
        {supplier === null ? `${t("Add New Supplier")}` : `${t("Update Supplier")}`}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{marginTop: "8px"}}>
          <Grid item>
            <TextField
              label={t("Supplier Name")}
              size="small"
              value={formData.supplierName}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.supplierName = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.supplierName === null ||
                formData.supplierName === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Supplier Name is required
                </div>
              )}
          </Grid>
          <Grid item>
            <TextField
              type={"number"}
              size="small"
              label={t("Vat Number")}
              value={formData.vatNumber}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.vatNumber = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.vatNumber === null || formData.vatNumber === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Vat Number is required
                </div>
              )}
          </Grid>

          <Grid item>
            <TextField
              type={"number"}
              size="small"
              label={t("Phone Number")}
              value={formData.phoneNumber}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.phoneNumber = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
          </Grid>

          <Grid item>
            <TextField
              label={t("Address")}
              size="small"
              value={formData.address}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.address = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>{t("Cancel")}</Button>
        <Button
          variant="contained"
          sx={{
            background: "#365b6d",
            "&:hover": { backgroundColor: "#365b6d" }
           
          }}
          onClick={handleSubmit}
        >
          {supplier === null ? `${t("Add Supplier")}` : `${t("Update Supplier")}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SupplierModal;
